import { GridColDef } from "@mui/x-data-grid-pro"
import { FnAxios, FnDialog, I18n, ParseHtml, RouterDOM } from "utilities/utilities";
import { BtnAddOnTableRender, BtnEditOnTableRender, DefaultParamCol } from "../Ticket/components/CreateColumnTable";
import { useEffect, useMemo, useState } from "react";
import { PaginationInterface, initRows } from 'components/DataGrid';
import { useLocation } from "react-router";
import { useForm } from "react-hook-form";
import { APIStatusCode, I18NextNs } from "enum/enum";
import moment from "moment";
import { numberFormatterLocale, parseFloatCheckValue } from "../Ticket/fnTickit";
import _ from "lodash";
import { GetMenuPermissionParamRoute } from "utilities/SystemFunction";

export function useTicketSoldList() {

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();

    const [nPrmUser, setNPrmUser] = useState(0);
    const [lstStatus, setLstStatus] = useState([]);
    const [lstOptionMuseum, setLstOptionMuseum] = useState([]);
    const [userType, setUserType] = useState(0)
    const [isPermission, setIsPermission] = useState<boolean>(false);
    const [loadingTable, setLoadingTable] = useState(false);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "sUpdate",
        sSortDirection: "desc",
    });

       
     //#region Form
     const formSearch = useForm({
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
    });
    // #endregion

    useEffect(() => {
        GetMenuPermissionParamRoute("/TicketSoldList", AxiosFn, setIsPermission, DialogFn);
    }, []);

    useEffect(() => {
        getStatusById();
        getCheckEmpMuseum();
        getTable(dataRow);
    }, [])

    const getCheckEmpMuseum = () => {
        DialogFn.BlockUI();
        AxiosFn.Get(`Ticket/GetCheckEmpMuseum`, { nMenuId: 20 }, (result) => {
            DialogFn.UnBlockUI();
            let objResult = result.objResult;
            setNPrmUser(objResult.nPrmUser)
            setUserType(objResult.nUserTypeID)
            setLstOptionMuseum(objResult.lstMuseum)
        });
    };

    const getStatusById = () => {
        DialogFn.BlockUI();
        AxiosFn.Get(`Ticket/GetStatusById`, { sMode: "S",sStatusId : "0,1,2,3,4,5" }, (result) => {
            DialogFn.UnBlockUI();
            let objResult = result.objResult;
            setLstStatus(objResult.lstStatus)
        });
    };


    const getTable = (p: PaginationInterface) => {
        DialogFn.BlockUI();
        setLoadingTable(true);
        let Param = {
            ...p,
            arrRows : [],
            sType: "sold",
            nStartDate: formSearch.getValues("nStartDate") ? formSearch.getValues("nStartDate").valueOf() : null,
            nEndDate: formSearch.getValues("nEndDate") ? formSearch.getValues("nEndDate").valueOf() : null,
            arrMuseumId: formSearch.getValues("arrMuseum") ?? [],
            arrStatusId: formSearch.getValues("arrStatusId") ?? [],
        };
        AxiosFn.Post(`SoldTicket/GetTableSoldCommitteeTicket`, Param, (result) => {
            setLoadingTable(false);
        DialogFn.UnBlockUI();
        let objResult = result.objResult;
            setDataRow({
                ...p,
                arrRows: objResult.lstData,
                nDataLength: objResult.nDataLength,
                nPageIndex: objResult.nPageIndex,
            });
        });
    };
    const onDelete = (arrSelect) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), () => {
            DialogFn.BlockUI();
            setLoadingTable(true);
            AxiosFn.Post(`SoldTicket/OnDeleteTableSoldTicket`, { lstId: arrSelect }, () => {
                getTable(dataRow)
                DialogFn.Success(I18n.SetText("Message.DeleteComplete", I18NextNs.labelComponent));
                DialogFn.UnBlockUI();
            });
        });
    }

    const handleClearSearch = () => {
        Object.keys(formSearch.getValues()).forEach((key => {
            formSearch.setValue(key, null);
            formSearch.clearErrors(key);
        }))
        getTable(dataRow);
    };


    const dataColumnSoldTicket: GridColDef[] = [
        {
            ...DefaultParamCol,
            field: "cAction",
            width: 60,
            minWidth : 60,
            headerName: "",
            sortable:false,
            type: "actions",
            flex: 0,
            renderHeader: () => {
                if ( isPermission && nPrmUser === 2) {
                    return (
                        <BtnAddOnTableRender
                            path={"/TicketSoldForm"}
                            nPermision={nPrmUser}
                        />
                    );
                }
            },
            renderCell: (params) => {
                return (
                    <BtnEditOnTableRender
                        path={"/TicketSoldForm"}
                        params={params}
                        nPermision={isPermission ? params.row.isView ? 1 : 2 : 1}
                    />
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "sDateSold",
            headerName: `${I18n.SetText("Ticket.DateSold")}`,
        },
        {
            ...DefaultParamCol,
            field: "nAmountMoney",
            headerName: `${I18n.SetText("Ticket.TotalMoney")}`,
            align: "right",
            flex: 1.5,
            renderCell: (params) => {
                return (
                    <>
                        {numberFormatterLocale(params.value,2)}
                    </>
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "sMuseum",
            headerName: `${I18n.SetText("Ticket.MuseumName")}`,
            align: "left",
            flex: 3,

        },
        {
            ...DefaultParamCol,
            field: "sSellName",
            headerName: `${I18n.SetText("Ticket.NameSold")}`,
            align: "left",
            flex: 2,
            renderCell: (params) => {
                return (
                    <>
                        {ParseHtml(params.value)}
                    </>
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "sUpdateName",
            headerName: `${I18n.SetText("Ticket.NameSaver")}`,
            align: "left",
            flex: 2,
        },
        {
            ...DefaultParamCol,
            field: "sUpdate",
            headerName: `${I18n.SetText("Ticket.DateSave")}`,
        },
        {
            ...DefaultParamCol,
            field: "sStatusName",
            headerName: `${I18n.SetText("Ticket.Status")}`,
            flex: 1.5,
        },
    ];

    return {
        dataColumnSoldTicket,
        getTable,
        onDelete,
        dataRow,
        loadingTable,
        formSearch,
        lstOptionMuseum,
        lstStatus,
        userType,
        nPrmUser,
        handleClearSearch,
        isView : !isPermission
    };
}


export function useTicketSoldForm() {

    //#region Hook
    const Router = RouterDOM();
    const AxiosFn = FnAxios()
    const DialogFn = FnDialog();
    const location = useLocation();
    // #endregion

    const objParamPath = useMemo(() => {
        const ParamId = new URLSearchParams(location.search).get("strParam");
        const ParamPrs = 2;
        return { ParamId, ParamPrs }
    }, [location.search])

    //#region State / Usememo
    const [lstTotalTicketSell, setLstTotalTicketSell] = useState([])
    const [nUserType, setNUserType] = useState(0);
    const [isPermission, setIsPermission] = useState<boolean>(false);
    const [isView, setIsView] = useState(false)
    const [statusId, setStatusId] = useState(0)
    const [policyId, setPolicyId] = useState(0)
    const [objMuseum, setObjMuseum] = useState({
        nMuseumID: null,
        sMuseumName: null,
    })
    const [option, setOption] = useState({
        lstMuseum: [],
        lstSeller: [],
        lstCurrencyNotes: [],
        lstCurrencyCoins: [],
        lstEmpFund: [],
        lstEmpMoney: [],
        lstTicketTypeNotFree: [],
    })
    const [defaultValues, setDefaultValues] = useState({
        dSoldTicket: null,
        nMuseumID: null,
        sMuseum: null,
        arrSeller: null,
        nEmpFund: null,
        nEmpMoney: null,
        lstSoldTicket: [],
        lstReturnTicket: [],
        lstCompareTicket: [],
        lstCurrencyNotes: [],
        lstCurrencyCoins: [],
        lstCurrencyElec: [],
        sRemarkFlow: null,
    })
    const [objTotal, setObjTotal] = useState({
        nTotalTicket: 0,
            nAmount: 0,
            nTotalRemark: 0,
    })
    const [objTotalMoney, setObjTotalMoney] = useState(0)
    
    // #endregion

    //#region Form
    const form = useForm({
        shouldFocusError: true,
        shouldUnregister: false,
        mode: "all",
        defaultValues: defaultValues
    });
    // #endregion

    const { watch, reset } = form;

    useEffect(() => {
        GetMenuPermissionParamRoute("/SupplyTicket", AxiosFn, setIsPermission, DialogFn);
        GetCheckEmpMuseum()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    useEffect(() => {
        form.reset(defaultValues);
    }, [defaultValues, form])

    const gotoBack = () => {
        Router.GoToPage("/TicketSoldList")
    }

    const GetCheckEmpMuseum = async () => {
        DialogFn.BlockUI();
        await AxiosFn.Get(`Ticket/GetCheckEmpMuseum`, { nMenuId: 20 }, async (result) => {
          DialogFn.UnBlockUI();
          let objResult = result.objResult;
          setNUserType(objResult.nUserTypeID)
          await getOptionInitialData(objResult.nUserTypeID)
        });
      };

    const handleSubmitForm = async (sMode) => {
        form.clearErrors()
        //check conditon is pass at table compare
        const lstSoldTicket = form.getValues("lstSoldTicket");
        let sMessage = "";
        if (sMode === "S") {
            sMessage = "ไม่สามารถยืนยันข้อมูลได้ เนื่องจากรายการจำหน่ายมีจำนวนบัตรไม่ครบถ้วน"
            let sMessageMax = "ไม่สามารถยืนยันข้อมูลได้ เนื่องจากรายการจำหน่ายเกินจำนวนที่สามารถจำหน่ายได้"
            let isPassListSold = true;
            let isPassMax = true;
            lstSoldTicket.forEach((item) => {
                if (item.isPass !== true && item.isRequire && !item.isFree) {
                    isPassListSold = false;
                    sMessage += `<br/>- ${item.sTypeTicket}`;
                }
                let nInput = (parseInt(item.nTotalTicket) + item.lstRemark.length)
                if(item.nMaxTicket < nInput && !item.isFree)
                {
                    isPassMax = false;
                    sMessageMax += `<br/>- ${item.sTypeTicket}`; // ${item.nMaxTicket} - ${nInput}`;
                }
            })
           
            if (!isPassMax) {
                DialogFn.Warning(sMessageMax);
                return;
            }
            if (!isPassListSold) {
                DialogFn.Warning(sMessage);
                return;
            }
           
        }
        let sumCurrencyElec = 0;
        if (form.getValues("lstCurrencyElec").length > 0) {
            form.getValues("lstCurrencyElec").forEach(element => {
                element.valueInputDecimal = element.valueInputDecimal === "" ? null : element.valueInputDecimal;
            });
             sumCurrencyElec = _.sumBy(form.getValues("lstCurrencyElec"), function (o) { return parseFloatCheckValue(o.valueInputDecimal); });
        }
        let InputSum = objTotalMoney + sumCurrencyElec;

        if (objTotal.nAmount !== InputSum && sMode === "S")
        {
            sMessage = "ไม่สามารถยืนยันข้อมูลได้ เนื่องจากจำนวนเงินไม่สอดคล้องกัน"
            DialogFn.Warning(sMessage);
            return;
        }
        

        const lstCompareTicket = form.getValues("lstCompareTicket");
        let findIndexFalse = lstCompareTicket.findIndex(f => f.isPass !== true);
        if (findIndexFalse !== -1 && sMode === "S") {
            sMessage = "ไม่สามารถยืนยันข้อมูลได้ เนื่องจากมีประเภทบัตรที่สถานะผิดปกติดังนี้ "
            let isPassListCompare = true;
            lstCompareTicket.forEach((item, index) => {
                if (item.isPass !== true ) {
                    isPassListCompare = false;
                    sMessage += `<br/>- ${item.sTypeTicket}`;
                }
            })
            if (!isPassListCompare) {
                DialogFn.Warning(sMessage);
                return;
            }
        }

        let objParam = {
            sMode: sMode,
            sIDTicketSold: objParamPath.ParamId,
            sIDMuseum: (nUserType === 1 ? objMuseum.nMuseumID : form.getValues("nMuseumID")) + "",
            nPolicyId: policyId,
            nTotalTicket: objTotal.nTotalTicket,
            sAmount: objTotal.nAmount+"",
            sEpayment: sumCurrencyElec+"",
            nEmpFund: form.getValues("nEmpFund"),
            nEmpMoney: form.getValues("nEmpMoney"),
            nSold: form.getValues("dSoldTicket").valueOf(),
            arrSeller: form.getValues("arrSeller") ?? [],
            lstSoldTicket: form.getValues("lstSoldTicket"),
            lstReturnTicket: form.getValues("lstReturnTicket"),
            lstCompareTicket: form.getValues("lstCompareTicket"),
            lstCurrencyElec: form.getValues("lstCurrencyElec"),
            lstCurrencyCoins: option.lstCurrencyCoins,
            lstCurrencyNotes: option.lstCurrencyNotes,
        };

        let objParamCheckReturn = {
            sIDMuseum: (nUserType === 1 ? objMuseum.nMuseumID : form.getValues("nMuseumID")) + "",
            lstSoldTicket: form.getValues("lstSoldTicket"),
            lstReturnTicket: form.getValues("lstReturnTicket"),
        };

        if(sMode === "S")
        {
            let { isPassReturn, messageFail } = await OnCheckTicketReturn(objParamCheckReturn);
            if (!isPassReturn) {
                let sMessage = `เลขที่รายการจำหน่ายและรายการคืนซ้ำกัน<br/>มีประเภทบัตรดังนี้${messageFail}<br/>คุณต้องการบันทึกข้อมูลหรือไม่ ?`
                DialogFn.SubmitWarning(sMessage, () => {
                    OnSave(objParam);
                })
                return;
            }
        }
      
       

        DialogFn.Submit(I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            OnSave(objParam);
        });

    }

    const OnSave = (objParam) => {
        AxiosFn.Post(`SoldTicket/OnSubmitTicketSold`, objParam, (result) => {
            DialogFn.CloseSubmitWarning()
            if (result.nStatusCode === APIStatusCode.Success) {
                DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                    gotoBack();
                });
            } else {
                DialogFn.Warning(result.sMessage, () => { gotoBack(); });
            }
        });
    }

    const OnCheckTicketReturn = async (objParam) => {
        let isPassReturn = false;
        let messageFail = false;
        DialogFn.BlockUI();
        await AxiosFn.Post(`SoldTicket/OnCheckSubmit`, objParam, (result) => {
            DialogFn.UnBlockUI();
            let objResult = result.objResult;
            isPassReturn = objResult.isPassReturn
            messageFail = objResult.sMessage
        }, () => { DialogFn.UnBlockUI(); });
        return {isPassReturn,messageFail};
    }

    const getSoldTicketType = (nMuseumID, dSold) => {
        if (!dSold) {
            return;
        }
        let param = {
            nMuseumID: nMuseumID,
            nSoldDate: moment(dSold).valueOf()
        }
        DialogFn.BlockUI();
        AxiosFn.Get(`SoldTicket/GetSoldTicketType`, param, (result) => {
            DialogFn.UnBlockUI();
            let objResult = result.objResult;
            if (!objResult) {
                setDefaultValues(defaultValues => ({
                    ...defaultValues,
                    nMuseumID: null,
                    dSoldTicket: null,
                    arrSeller: null,
                    lstSoldTicket: [],
                    lstReturnTicket: [],
                    lstCompareTicket: [],
                    lstCurrencyNotes: [],
                    lstCurrencyCoins: [],
                    lstCurrencyElec: [],
                }))
                DialogFn.Warning(result.sMessage);
                return;
            }
            setPolicyId(objResult.nPolicyID)
            setOption(option => ({
                ...option,
                lstEmpFund: objResult.lstEmpFund,
                lstEmpMoney: objResult.lstEmpMoney,
                lstSeller: objResult.lstSeller,
                lstTicketTypeNotFree: objResult.lstTicketTypeNotFree,
            }))
            let deepCopy = _.cloneDeep(objResult.lstTypeTicket);
            setLstTotalTicketSell(deepCopy)

            setDefaultValues(defaultValues => ({
                ...defaultValues,
                nMuseumID: nMuseumID,
                dSoldTicket: dSold,
                arrSeller: objResult.arrUserwithdraw,
                lstSoldTicket: objResult.lstTypeTicket,
                lstReturnTicket: objResult.lstTypeTicketReturn,
                lstCompareTicket: objResult.lstTypeTicketCompare,
                lstCurrencyNotes: [],
                lstCurrencyCoins: [],
                lstCurrencyElec: objResult.lstTicketTypeNotFree,
            }))
            reset({
                ...watch(),
            });
        }, null, () => DialogFn.UnBlockUI());
    }

    const getOptionInitialData = async (nUserTypeID) => {
        DialogFn.BlockUI();
        if (objParamPath.ParamId) {
            await AxiosFn.Get(`SoldTicket/GetFormInfoSoldTicket`, { sSoldTicketID: objParamPath.ParamId }, (result) => {
                DialogFn.UnBlockUI();
                let objResult = result.objResult;
                if (objResult) {
                    // setIsView(false)
                    setStatusId(parseInt(objResult.sMode))
                    setIsView(!([0,3,4].includes(objResult.sMode) && objResult.isCreate))
                    setObjMuseum({
                        nMuseumID: parseInt(objResult.objSold.sIDMuseum),
                        sMuseumName: objResult.objSold.sMuseum,
                    })

                    setOption(option => ({
                        ...option,
                        lstMuseum: objResult.lstMuseum,
                        lstEmpFund: objResult.lstEmpFund,
                        lstEmpMoney: objResult.lstEmpMoney,
                        lstSeller: objResult.lstSellerOption,
                        lstCurrencyNotes: objResult.objSold.lstCurrencyNotes,
                        lstCurrencyCoins: objResult.objSold.lstCurrencyCoins,
                        lstTicketTypeNotFree: objResult.lstTicketTypeNotFree,
                    }))

                    let deepCopy = _.cloneDeep(objResult.objSold.lstSoldTicket);
                    setLstTotalTicketSell(deepCopy)

                    setDefaultValues(defaultValues => ({
                        ...defaultValues,
                        nMuseumID: parseInt(objResult.objSold.sIDMuseum),
                        sMuseum: objResult.objSold.sMuseum,
                        dSoldTicket: moment(objResult.objSold.nSold),
                        arrSeller: objResult.objSold.arrSeller,
                        nEmpFund: objResult.objSold.nEmpFund,
                        nEmpMoney: objResult.objSold.nEmpMoney,
                        lstSoldTicket: objResult.objSold.lstSoldTicket,
                        lstReturnTicket: objResult.objSold.lstReturnTicket,
                        lstCompareTicket: objResult.objSold.lstCompareTicket,
                        lstCurrencyNotes: objResult.objSold.lstCurrencyNotes,
                        lstCurrencyCoins: objResult.objSold.lstCurrencyCoins,
                        lstCurrencyElec: objResult.objSold.lstCurrencyElec,
                        sRemarkFlow : objResult.sRemark
                    }))

                    reset({
                        ...watch(),
                    });
                }
            }, null, () => DialogFn.UnBlockUI());
            return;
        }
        await AxiosFn.Get(`SoldTicket/GetFormInitialTicketSold`, null, (result) => {
            DialogFn.UnBlockUI();
            let objResult = result.objResult;
            setOption(option => ({
                ...option,
                lstMuseum: objResult.lstMuseum,
                lstCurrencyNotes: objResult.lstCurrencyNotes,
                lstCurrencyCoins: objResult.lstCurrencyCoins,
            }))
            setObjMuseum({
                nMuseumID: objResult.nMuseumID,
                sMuseumName: objResult.sMuseumName,
            })

            setDefaultValues(defaultValues => ({
                ...defaultValues,
                // nMuseumID: objResult.nMuseumID,
                sMuseum: objResult.sMuseumName,
                lstCurrencyNotes: objResult.lstCurrencyNotes,
                lstCurrencyCoins: objResult.lstCurrencyCoins,
            }))

            // if (objResult.isDefaultDate && nUserTypeID === 1) {
            //     getSoldTicketType(objResult.nMuseumID, moment())
            // }
        }, null, () => DialogFn.UnBlockUI());
    };


    return {
        statusId,
        isView : isPermission ? isView : true,
        objParamPath,
        form,
        gotoBack,
        handleSubmitForm,
        objMuseum,
        option,
        defaultValues,
        getSoldTicketType,
        setObjTotal,
        setObjTotalMoney,
        nUserType,
        lstTotalTicketSell,
        setLstTotalTicketSell
    }

}